<template>
  <div class="new padding80">
    <Header :current="2"></Header>
    <div class="title">
      <img src="../../assets/new/bg.png" alt="">
      <div class="titletext">
        <div class="titletext1">作为客户最佳的合作伙伴</div>
        <div class="titletext2">提供安全、敏捷的业务应用平台</div>
      </div>
    </div>
    <div class="contents">
      <img src="../../assets/new/newDetail_szhzx6.png" alt="">
      <div class="content">
        <div class="content1">以创新思维深耕金融科技，徕檬助力国内中小银行数字化转型</div>
        <div class="content2">基于大数据、人工智能、区块链等新兴技术的金融科技正加快渗透银行的营销、风控、运营、业务等方方面面；疫情时代下，“宅生活”催生出了更强烈的线上金融服务需求，现有银行服务数字化水平面临实质性挑战。银行数字化转型进度在加速。</div>
        <div class="content3" @click="goDetail(1)">了解更多</div>
      </div>
    </div>
    <div class="contents">
      <img src="../../assets/new/newDetail_zbhl4.png" alt="">
      <div class="content">
        <div class="content1">紧握直播红利，万亿级城商行与徕檬直播团队携手打造PUGC级金融直播间</div>
        <div class="content2">据悉，徕檬直播团队协助全球银行品牌百强、某国内资产总额万亿级城商行于近两月陆续完成包括总行营业部、信用卡中心、各分支行在内数十间不同规格线下金融直播间的搭建，并已陆续完成调试、投入使用。其中，总行和信用卡中心配备PUGC级金融直播间，各分行和支行配备UGC级金融直播间。</div>
        <div class="content3" @click="goDetail(2)">了解更多</div>
      </div>
    </div>

    <div class="contents">
      <img src="../../assets/new/new1.jpg" alt="">
      <div class="content">
        <div class="content1">徕檬受邀携最新“视频云营业厅”方案参展蚂蚁金服2020  INCLUSION 外滩大会</div>
        <div class="content2">INCLUSION·外滩大会是由上海市人民政府作为指导单位，蚂蚁集团、支付宝共同主办的全球金融科技盛会。大会致力于推动金融科技的普惠，搭建开放的国际交流、共享平台，邀请全球具有影响力的金融科技领军企业和专家学者，共同探讨区块链、物联网、人工智能等前沿技术在金融、经济、商业、环境等领域的应用和创新，推动全球商业、经济与社会生态的合作发展。</div>
        <div class="content3" @click="goDetail(3)">了解更多</div>
      </div>
    </div>
    <div class="contents">
      <img src="../../assets/new/new2.jpg" alt="">
      <div class="content">
        <div class="content1">激活银行私域流量，徕檬直播助力宁波银行信用卡新业务模式落地</div>
        <div class="content2">据悉,国内资产总额万亿级城商行宁波银行已于上周完成主题为“为挚爱甄选”的内购专场带货直播。该场直播以激活信用卡私域流量为目标,直播对象主要为行内员工及宁波银行信用卡高净值客户。整场直播由宁波银行信用卡主办,徕檬直播负责全案策划(含设备器材、直播间搭建、直播编导策划、活动策划),直播流程管理并提供主播支持。</div>
        <div class="content3" @click="goDetail(4)">了解更多</div>
      </div>
    </div>
    <div class="contents">
      <img src="../../assets/new/new3.jpg" alt="">
      <div class="content">
        <div class="content1">徕檬“银行视频云营业厅”亮相本届蚂蚁金服2020 INCLUSION·外滩大会，获得业界广泛好评</div>
        <div class="content2">2020 INCLUSION·外滩大会已于2020年9月26日正式闭幕，为期3天的大会以“科技让未来更普惠”为主题，聚焦数字普惠开放、金融科技创新、全球生态共建、商业价值变革、绿色和可持续发展五大前沿话题。本次外滩大会吸引了47家金融与科技企业参展，并通过40余场论坛连接了全球超过500位具有影响力的金融科技大咖、顶尖学者、行业领军人物，共同见证世界...</div>
        <div class="content3" @click="goDetail(5)">了解更多</div>
      </div>
    </div>
    <div class="contents">
      <img src="../../assets/new/new6.png" alt="">
      <div class="content">
        <div class="content1">徕檬——让金融和商业生态更智慧、更温馨</div>
        <div class="content2">公司核心团队有着多年金融行业和移动互联网行业的从业经验，对银行业数字化运营发展历程有着深刻的理解，面向Bank4.0时代帮助客户打造移动化银行、数字化银行、场景银行、智能银行。徕檬自成立以来，已先后与台州银行、阿里云、蚂蚁金服、华夏银行、天津银行、常熟农商银行、湖南三湘银行、上海农商银行SRCB、长沙银行、无锡锡商银行等国内知名银行与金融科技机构展开合作</div>
        <div class="content3" @click="goDetail(6)">了解更多</div>
      </div>
    </div>
    <div class="hzhb">
      <div class="hzhb1">合作伙伴</div>
      <div class="hzhb2">PARTNER</div>
    </div>
    <div class="yhkh">
      <img src="../../assets/new/hezuo/yhkh-left.png" alt="">
      <div>银行客户</div>
      <img src="../../assets/new/hezuo/yhkh-right.png" alt="">
    </div>
    <div class="hezuo">
      <img class="hezuoimg" src="../../assets/new/hezuo/taizhou.png" alt="">
      <img class="hezuoimg" src="../../assets/new/hezuo/huanghe.png" alt="">
      <img class="hezuoimg" src="../../assets/new/hezuo/tianjin.png" alt="">
      <img class="hezuoimg" src="../../assets/new/hezuo/changshu.png" alt="">
      <img class="hezuoimg" src="../../assets/new/hezuo/sanxiang.png" alt="">
      <img class="hezuoimg" src="../../assets/new/hezuo/huaxia.png" alt="">
    </div>
    <div class="hezuo2">
      <img class="hezuoimg" src="../../assets/new/hezuo/jiangxi.png" alt="">
      <img class="hezuoimg" src="../../assets/new/hezuo/ningbo.png" alt="">
      <img class="hezuoimg" src="../../assets/new/hezuo/tianjinns.png" alt="">
      <!-- <img class="hezuoimg" src="../../assets/new/hezuo/zhongxin.png" alt=""> -->
      <img class="hezuoimg" src="../../assets/new/hezuo/wuxi.png" alt="">
      <img class="hezuoimg" src="../../assets/new/hezuo/tailong.png" alt="">
      <div class="hezuoimg"></div>
    </div>
    <div class="yhkh">
      <img src="../../assets/new/hezuo/yhkh-left.png" alt="">
      <div>非银行客户</div>
      <img src="../../assets/new/hezuo/yhkh-right.png" alt="">
    </div>
    <div class="hezuo">
      <img class="feihezuoimg" src="../../assets/new/hezuo/aliyun.png" alt="">
      <img class="feihezuoimg" src="../../assets/new/hezuo/mayijinfu.png" alt="">
      <img class="feihezuoimg" src="../../assets/new/hezuo/zhongxinzq.png" alt="">
      <img class="feihezuoimg" src="../../assets/new/hezuo/qichen.png" alt="">
    </div>
    <div class="hezuo2">
      <img class="feihezuoimg" src="../../assets/new/hezuo/hongxinqiche.png" alt="">
      <img class="feihezuoimg" src="../../assets/new/hezuo/jiuyinqiche.png" alt="">
      <div class="feihezuoimg"></div>
      <div class="feihezuoimg"></div>
    </div>
    
    
    <Footer></Footer>

  </div>
</template>

<script>
export default {
  name: "new",
  data() {
    return {
      isShow: false,
      jobList: Array,
      dtShow: true
    };
  },
  mounted() {

  },
  methods: {
    goDetail(num){
      if (num==1) {
        this.$router.push({name:'newDetail_szhzx'})
      }else if (num==2) {
        this.$router.push({name:'newDetail_zbhl'})
      }else if (num==3) {
        this.$router.push({name:'newDetail'})
      }else if (num==4) {
        this.$router.push({name:'newDetail_liul'})
      }else if (num==5) {
        this.$router.push({name:'newDetail_spzs'})
      }else if (num==6) {
        this.$router.push({name:'newDetail_jrsyst'})
      }

    }
  }
};
</script>

<style scoped lang="less">
.titletext{
  width: 100%;
  text-align: center;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #FFFFFF;
  position: relative;
  margin-top: -220px;
  margin-bottom: 130px;
  .titletext1{
    font-size: 50px;
    font-weight: bold;
    color: #FFFFFF;
    letter-spacing:8px
  }
  .titletext2{
    font-size: 24px;
    margin-top: 34px;
  }
}
.contents:hover{
  box-shadow: 0px 2px 28px 0px rgba(0, 0, 0, 0.14), 0px 12px 34px 0px rgba(60, 60, 60, 0.06);
}
.contents{
    width: 900px;
    margin: 0px auto;
    margin-top: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    color: #141414;
    margin-bottom: 40px;
    border-radius: 25px;
    box-shadow: 0px 12px 34px 0px rgba(60, 60, 60, 0.06);
    background-color: #fff;
    display: flex;
    padding: 20px;
    img{
      width: 216px;
      height: 148px;
      border-radius: 10px;
    }
    .content{
      margin-left: 20px;
      flex: 1;
      .content1{
        font-weight: bold;
        font-size: 17px;
        margin-top: 6px;
        width: 839px*0.75;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      .content2{
        color: #666666;
        font-size: 13px;
        margin-top: 16px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
      .content3{
        width: 70px;
        height: 24px;
        line-height: 24px;
        border-radius: 4px;
        border: 1px solid #999999;
        color: #545454;
        font-size: 9px;
        text-align: center;
        margin-top: 20px;
        cursor: pointer;
      }
    }
  }
  .hzhb{
    text-align: center;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #291D1D;
    margin-top: 50px;
    .hzhb1{
      font-size: 38px;
      font-weight: bold;
    }
    .hzhb2{
      font-size: 15px;
      margin-top: 6px;
    }
  }
  .yhkh{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 70*0.75px;
    div{
      font-size: 28*0.75px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #999999;
      padding: 0px 16px;
    }
    img{
      width: 106*0.75px;
      height: 1px;
      margin-top: 16px;
    }
  }
  
  .hezuo{
    width: 900px;
    margin: 0px auto;
    margin-top: 50*0.75px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;    
    .hezuoimg{
      width: 185*0.75px;
    } 
    .feihezuoimg{
      width: 288*0.75px;
    }  
  }
  .hezuo2{
    width: 900px;
    margin: 0px auto;
    margin-top: 20*0.75px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;    
    .hezuoimg{
      width: 185*0.75px;
    }
    .feihezuoimg{
      width: 288*0.75px;
    } 
    margin-bottom: 50px;
  }
</style>
